import JobManagement from 'components/jobs/JobManagement';
import React from 'react';
import './LookingFor.css';

export default function LookingFor() {
  return (
    <div>
      <div className="d-flex justify-content-between flex-md-wrap align-items-center position-relative mb-2">
        <div className="header-title">
          {/* <h4 className="fw-semibold text-dark">Job Post</h4> */}
        </div>
      </div>
      <JobManagement />
    </div>
  );
}
